module.exports = __webpack_public_path__ + "static/assets/c42650b85518b3768b05e5afa4c63f05.svg";